import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { API_BASE_URL } from '../config';
import apiFetch from '../utils/apiFetch';

const STATUS_COLORS = {
  pending: 'warning',
  approved: 'info',
  paid: 'success',
};

function PartnerEarnings() {
  const [earnings, setEarnings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch(`${API_BASE_URL}/admin/partner/earnings`)
      .then((res) => res.json())
      .then((json) => setEarnings(json.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const totalPaid = earnings
    .filter((e) => e.status === 'paid')
    .reduce((sum, e) => sum + (e.amountYen || 0), 0);

  const totalPending = earnings
    .filter((e) => e.status !== 'paid')
    .reduce((sum, e) => sum + (e.amountYen || 0), 0);

  if (loading) {
    return (
      <Layout>
        <div className="text-center py-5">Loading...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <h4 className="mb-4 fw-bold">Earnings</h4>

      <div className="row g-3 mb-4">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div style={{ fontSize: '0.75rem', color: '#8a94ad' }}>Total Paid</div>
              <div className="fw-bold text-success" style={{ fontSize: '1.5rem' }}>
                {'\u00a5'}{totalPaid.toLocaleString()}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div style={{ fontSize: '0.75rem', color: '#8a94ad' }}>Pending / Approved</div>
              <div className="fw-bold text-warning" style={{ fontSize: '1.5rem' }}>
                {'\u00a5'}{totalPending.toLocaleString()}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body p-0">
          <table className="table table-sm mb-0" style={{ fontSize: '0.8125rem' }}>
            <thead className="table-light">
              <tr>
                <th>Period</th>
                <th>Scans</th>
                <th>Stores</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {earnings.map((e) => (
                <tr key={e.id}>
                  <td>
                    {new Date(e.periodStart).toLocaleDateString('ja-JP')} - {new Date(e.periodEnd).toLocaleDateString('ja-JP')}
                  </td>
                  <td>{e.scanCount}</td>
                  <td>{e.storeCount}</td>
                  <td className="fw-semibold">{'\u00a5'}{(e.amountYen || 0).toLocaleString()}</td>
                  <td>
                    <span className={`badge bg-${STATUS_COLORS[e.status] || 'secondary'}`}>
                      {e.status}
                    </span>
                  </td>
                </tr>
              ))}
              {earnings.length === 0 && (
                <tr><td colSpan={5} className="text-center text-muted py-4">No earnings yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}

export default PartnerEarnings;
